module.exports = __webpack_public_path__ + "821e154131d16766a9ab8a89926e53ce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/tablet-s.png
// module id = 2618
// module chunks = 0